import * as React from 'react';
import { builder } from '@builder.io/react';
import _ from 'lodash';

const BUILDER_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY;
builder.init(BUILDER_API_KEY);

const BuilderContext = React.createContext();

const builderModels = ['announcement-banner', 'events-banner'];

const fetchBuilderData = async ({req, res, ctx}) => {
  const data = await Promise.all(
    builderModels.map(async model => {
      const content = await builder.get(model, {
        req,
        res,
        url: ctx.asPath
      }).promise();

      if (!content && res) {
        res.status = 404;
      }
      return {
        model,
        content
      };
    })
  );
  const store = {};
  data.forEach(model => {
    store[_.camelCase(model.model)] = model.content;
  });
  return store;
};

function BuilderProvider({ children, data }) {
  return <BuilderContext.Provider value={data}>{children}</BuilderContext.Provider>;
}

function useBuilder() {
  const context = React.useContext(BuilderContext);
  if (context === undefined) {
    throw new Error('useBuilder must be used within a BuilderProvider');
  }
  return context;
}

export { BuilderProvider, useBuilder, fetchBuilderData };
